import { render } from "./IzinNonGtk.vue?vue&type=template&id=597bbd34&scoped=true"
import script from "./IzinNonGtk.vue?vue&type=script&lang=js"
export * from "./IzinNonGtk.vue?vue&type=script&lang=js"

import "./IzinNonGtk.vue?vue&type=style&index=0&id=597bbd34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597bbd34"]])

export default __exports__